import { ApiManager } from "./../data/ApiManager";
import { DataProviderContext, useResourceContext } from "react-admin";
import { useContext } from "react";

export const useSearchFields = (
  props: any,
  fields: Array<string>,
  reference?: string
) => {
  const resource = useResourceContext(props);
  const dataProvider = useContext(DataProviderContext) as ApiManager;
  dataProvider.setSearchFields(reference ? reference : resource, fields);
  return reference ? reference : resource;
};
